







































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { mapState } from 'vuex';

import { required, email } from 'vuelidate/lib/validators';
import { formMixin } from '~/utils/form';

import EmailInput from '~/components/inputs/EmailInput.vue';

@Component({
  layout: 'signin',

  components: { EmailInput },

  middleware: 'noauth',

  validations: {
    email: { required, email },
  },

  computed: {
    ...mapState('lang', [
      'locale',
    ]),
  },

  head () {
    const self: any = this;
    return {
      title: `${self.$t('account.passwordLost.title')} - On Piste`,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.$t('account.passwordLost.title')} - On Piste`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://www.onpiste.com/img/sign/img__rossignol__trail3.png',
        },
      ],
    };
  },
})
export default class PasswordLost extends mixins(formMixin) {
  locale: string;

  hasSentEmail: boolean = false;
  email: string = '';

  /* Returns the login form defined in the store */
  get loginForm (): Types.LoginForm {
    return this.$store.state.user.loginForm;
  }

  mounted () {
    // Will prefill email if is defined in store
    this.email = this.loginForm.email;
    this.$store.commit('user/SET_SIGN_IMAGE', '/img/sign/img__rossignol__trail3.png');
  }

  /*
    Submitting the form will trigger an API call to send a resetPassword link to
    this.email
  */
  submit () {
    this.formMixin_handleSubmit(async () => {
      await this.$store.dispatch('user/sendPasswordResetLink', { email: this.email, lang: this.locale });
      this.hasSentEmail = true;
    });
  }

  /*
    This method resets the view to have a new attempt on send an link to
    another email address
  */
  tryAgain () {
    this.formMixin_busy = false;
    this.hasSentEmail = false;
  }
}
